/*
 * @Description:
 * @Author: pliybird
 * @Date: 2022-02-14 22:41:54
 * @LastEditTime: 2025-11-10 10:52:30
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import News from "@/views/News";
import NewsDetail from "../views/NewsDetail";
import CustomerCase from "../views/CustomerCase/CustomerCase.vue";
import ServiceAbility from "../views/serviceAbility/ServiceAbility.vue";
import goOverseasIndex from "../views/goOverseas/Index";
import aboutUsIndex from "../views/aboutUs/Index";

import VyungCPQ from "@/views/ProductService/VyungCPQ.vue";
import VyungFCST from "../views/ProductService/VyungFCST.vue";
import VyungLTC from "../views/ProductService/VyungLTC.vue";
import VyungService from "../views/ProductService/VyungService.vue";
import VyungWorkflow from "../views/ProductService/VyungWorkflow.vue";
import VyungLoyalty from "../views/ProductService/VyungLoyalty.vue";

import Semiconductor from "../views/IndustrySolution/Semiconductor.vue";

import AutomobileAccessory from "../views/IndustrySolution/AutomobileAccessory.vue";
import Education from "../views/IndustrySolution/Education.vue";
import Disperse from "../views/IndustrySolution/Disperse.vue";
import Medicine from "../views/IndustrySolution/Medicine.vue";
import RetailFMCG from "../views/IndustrySolution/RetailFMCG.vue";
import CrmSemiconductor from "../views/IndustrySolution/crm/Semiconductor";
import CrmNewEnergy from "../views/IndustrySolution/crm/NewEnergy.vue";
import CrmElecConsume from "../views/IndustrySolution/crm/ElecConsume.vue";
import CrmHighTech from "../views/IndustrySolution/crm/HighTech.vue";
import SinglePageHome from "../views/SinglePageHome/index.vue";
import DynamicsPowerPlatform from "@/views/DynamicsPowerPlatform/index.vue";
import i18n from "../lang";

Vue.use(VueRouter);

const routes = [
  {
    path: "/", // 定义中文路由
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
        meta: {
          title:
            "汉得微扬官网 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
          content: {
            keywords:
              "CRM,微软CRM/ERP,Dynamics CRM/ERP,CRM管理系统,客户关系管理系统,会员管理系统,制造CRM,零售CRM,快消CRM,基金CRM,私募CRM,财富管理CRM,证券CRM,地产CRM",
            description:
              "上海汉得信息（股票代码：300170）控股，微软CRM全球核心合作伙伴，提供微软Dynamics CRM , ERP, Azure云, Power BI 等，专注于零售快消、金融、制造、地产CRM和ERP解决方案。",
          },
        },
      },
      {
        path: "service",
        name: "service",
        component: ServiceAbility,
        meta: {
          title:
            "服务能力 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "news",
        name: "news",
        component: News,
        meta: {
          title:
            "新闻资讯 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "news/:id",
        name: "NewsDetail",
        component: NewsDetail,
        meta: {
          title: "",
          content: {
            keywords: "",
            description: "",
          },
        },
      },
      {
        path: "cases/:id",
        name: "CasesDetail",
        component: NewsDetail,
        meta: {
          title: "",
        },
      },
      {
        path: "overseas",
        name: "overseas",
        component: goOverseasIndex,
        meta: {
          title:
            "中企出海 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },

      {
        path: "about_us",
        name: "about_us",
        component: aboutUsIndex,
        meta: {
          title:
            "关于我们 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
          scrollToTop: true,
        },
      },
      {
        path: "cases",
        name: "cases",
        component: CustomerCase,
        meta: {
          title:
            "客户案例 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },

      {
        path: "product/cpq",
        name: "VyungCPQ",
        component: VyungCPQ,
        meta: {
          title:
            "选配报价 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "product/fcst",
        name: "VyungFCST",
        component: VyungFCST,
        meta: {
          title:
            "销售预测 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "product/ltc",
        name: "VyungLTC",
        component: VyungLTC,
        meta: {
          title:
            "销售管理 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "product/service",
        name: "VyungService",
        component: VyungService,
        meta: {
          title:
            "服务管理 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "product/workflow",
        name: "VyungWorkflow",
        component: VyungWorkflow,
        meta: {
          title:
            "流程管理 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "product/loyalty",
        name: "VyungLoyalty",
        component: VyungLoyalty,
        meta: {
          title:
            "忠诚度会员 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/semiconductor",
        name: "Semiconductor",
        component: Semiconductor,
        meta: {
          title:
            "ERP半导体行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/auto",
        name: "AutomobileAccessory",
        component: AutomobileAccessory,
        meta: {
          title:
            "ERP汽配行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/disperse",
        name: "Disperse",
        component: Disperse,
        meta: {
          title:
            "ERP离散行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/edu",
        name: "Education",
        component: Education,
        meta: {
          title:
            "ERP教育行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/medicine",
        name: "Medicine",
        component: Medicine,
        meta: {
          title:
            "ERP医药行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/fmcg",
        name: "RetailFMCG",
        component: RetailFMCG,
        meta: {
          title:
            "ERP零售快消行业 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/crm/semiconductor",
        name: "CrmSemiconductor",
        component: CrmSemiconductor,
        meta: {
          title:
            "半导体 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/crm/hightech",
        name: "CrmHighTech",
        component: CrmHighTech,
        meta: {
          title:
            "高科技 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/crm/elecconsume",
        name: "CrmElecConsume",
        component: CrmElecConsume,
        meta: {
          title:
            "电子消费品 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
      {
        path: "solution/crm/newenergy",
        name: "CrmNewEnergy",
        component: CrmNewEnergy,
        meta: {
          title:
            "新能源 - 微软CRM金牌伙伴|Dynamics CRM/ERP解决方案|全球核心伙伴",
        },
      },
    ],
  },
  {
    path: "/:lang(en_US|ja_JP)", // 国际化英文日文启用单页
    name: "SinglePageHome",
    component: SinglePageHome,
    meta: {
      title: "Shanghai Hand Vyung Information Technology Co.,LTD",
    },
  },
  {
    path: "/:lang(zh_CN|en_US)/dynamics-power-platform", // 汉得微扬审批流单页
    name: "DynamicsPowerPlatform",
    component: DynamicsPowerPlatform,
    meta: {
      title: "汉得微扬审批流",
    },
  },
  {
    path: "*",
    redirect: "/", // 默认重定向到默认中文语言
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", to.meta.content.keywords);
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.content.description);
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  const lang = to.params.lang; // 从路由参数中获取语言标识

  if (lang && ["en_US", "zh_CN", "ja_JP"].includes(lang)) {
    i18n.locale = lang;
    // window.sessionStorage.setItem('lang',lang)
  }
  next();
  window.scrollTo(0, 0);
});

export default router;
